import { authClient } from '@/shared/api/auth';
import { decodeAccessToken, resolveSafeReturnUrl, resourcePathByRole } from '@/shared/utils';

/**
 * Where the Profile page's Back button sends the user: the validated same-origin `returnUrl` from
 * the URL if present, otherwise the signed-in user's portal (`/admin` or `/inspector`) derived from
 * their access-token role. Falls back to the app root only when there is no session/role to read.
 */
export const resolveBackDestination = (returnUrl: string | null | undefined): string => {
  const safeReturnUrl = resolveSafeReturnUrl(returnUrl);
  if (safeReturnUrl) {
    return safeReturnUrl;
  }

  const accessToken = authClient.getAccessToken();
  const role = accessToken ? decodeAccessToken(accessToken).role : null;
  const [resource] = role ? (resourcePathByRole(role) ?? []) : [];

  return resource ?? '/';
};

/**
 * Navigates Back from the Profile page. A full-page navigation (not a router transition) because the
 * destination — the originating app or the user's portal — is a separate SPA under the same host.
 */
export const navigateBack = (returnUrl: string | null | undefined): void => {
  window.location.assign(resolveBackDestination(returnUrl));
};
